<div class="forgot-wrapper">
  <div class="forgot-card">

    <div class="forgot-card-left">
      <div class="forgot-logo-container">
        <img src="assets/Global/Icon_SINCO.png" alt="Grupo SINCO" class="forgot-logo-img" />
      </div>
      <h1>Recupera tu acceso</h1>
      <p>Te enviaremos las instrucciones necesarias para restablecer tu contraseña.</p>

      <div class="forgot-features">
        <div class="feature-item">
          <i class="fa fa-shield"></i>
          <span>Proceso seguro</span>
        </div>
        <div class="feature-item">
          <i class="fa fa-envelope"></i>
          <span>Instrucciones por correo</span>
        </div>
        <div class="feature-item">
          <i class="fa fa-clock-o"></i>
          <span>Respuesta en menos de 24 horas</span>
        </div>
      </div>
    </div>

    <div class="forgot-card-right">

      <div class="forgot-form-header">
        <h2>Restablecer contraseña</h2>
        <p>Ingresa tu correo electrónico registrado.</p>
      </div>

      <ng-container *ngIf="!forgotSuccess">
        <div class="input-group">
          <i class="fa fa-envelope input-icon-fa"></i>
          <input
            type="email"
            [(ngModel)]="forgotEmail"
            name="forgotEmail"
            placeholder="Escribe tu correo electrónico"
            autocomplete="email"
            [class.input-error]="forgotError"
          />
        </div>

        <div class="error-message" *ngIf="forgotError">
          <i class="fa fa-exclamation-circle"></i>
          <span>{{ forgotError }}</span>
        </div>

        <button class="btn-submit" (click)="onSubmit()" [disabled]="!forgotEmail.trim() || isLoading">
          <span>{{ isLoading ? 'Enviando...' : 'Enviar' }}</span>
          <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
        </button>
      </ng-container>

      <div class="success-message" *ngIf="forgotSuccess">
        <div class="success-icon">
          <i class="fa fa-check"></i>
        </div>
        <h3>¡Solicitud enviada!</h3>
        <p>En breve contactaremos contigo para restablecer tu acceso.</p>
      </div>

      <div class="back-link">
        <a href="#" (click)="goBack()">
          <i class="fa fa-arrow-left"></i>
          Volver al inicio de sesión
        </a>
      </div>

    </div>
  </div>
</div>
